module.exports = __webpack_public_path__ + "media/country_flags/cf-c024745f.png";